{
  "deleteConfirmation": {
    "title": "Confirm Deletion",
    "description": "Are you sure you want to delete this item? This action cannot be undone.",
    "confirm": "Delete",
    "cancel": "Cancel"
  },
  "confirmation": {
    "title": "Confirm Action",
    "description": "Are you sure you want to continue?",
    "confirm": "Confirm",
    "cancel": "Cancel"
  },
  "error": {
    "generic": "An error occurred. Please try again.",
    "chatDisabled": "Chat is disabled by feature flag."
  },
  "sidebar": {
    "open": "Open panel",
    "close": "Close panel"
  },
  "loading": "Loading...",
  "saving": "Saving...",
  "cancel": "Cancel",
  "create": "Create",
  "today": "Today",
  "date": "Date",
  "done": "Done",
  "toast": {
    "dismiss": "Dismiss"
  }
}
